<template>
    <PageLoading v-if="isLoading" />
    <div v-else class="main-wrap courses-page">
        <div
            class="bg-img"
            :style="{
                'background-image':
                    'url(' +
                    require('@/assets/images/areas_bg_img_min.jpg') +
                    ')',
            }"
        ></div>
        <h1>{{ $tc('general.training_areas', 2) }}</h1>
        <div class="categories-wrap">
            <router-link
                v-for="(area, index) in areas"
                :key="index"
                :to="{
                    name: 'Courses',
                    params: {
                        areaId: area.id,
                    },
                }"
                class="category-box"
            >
                <AreaThumb :area="area"></AreaThumb>
            </router-link>
        </div>
    </div>
</template>

<script>
import AreaThumb from '@/components/AreaThumb'
import PageLoading from '@/components/PageLoading'
import areasService from '@/services/modules/areas'

const loadingKeys = {
    fetchingPage: 'fetching-page',
    fetchingAreas: 'fetching-areas',
}

export default {
    name: 'Courses',

    components: {
        PageLoading,
        AreaThumb,
    },

    data() {
        return {
            areas: [],
        }
    },

    computed: {
        isLoading() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.fetchingPage
            ).length
        },
    },

    created() {
        this.loadingAdd(loadingKeys.fetchingPage)
        this.fetchAreas()
    },

    mounted() {
        setTimeout(() => {
            this.loadingRemove(loadingKeys.fetchingPage)
        }, 500)
    },

    methods: {
        async fetchAreas() {
            this.loadingAdd(loadingKeys.fetchingAreas)

            let parameters = {
                filter: {
                    active: true,
                    published: true,
                },
                orderBy: [
                    {
                        column: 'title',
                        direction: 'asc',
                    },
                ],
            }

            let response = await areasService.retrieve(parameters)

            if (response.status === 200) {
                this.areas = response.data.results
            }

            this.loadingRemove(loadingKeys.fetchingAreas)
        },
    },
}
</script>
